/* eslint-disable camelcase */
import { ActionType } from 'typesafe-actions';
import { UserAddresses } from '../auth/types';
import { ProductData } from '../product/types';
import * as actions from './actions';

export type OrderAction = ActionType<typeof actions>;

/**
 * Action types
 */
export enum OrderActionTypes {
  ORDER_LIST_REQUEST = '@order/ORDER_LIST_REQUEST',
  ORDER_LIST_SUCCESS = '@order/ORDER_LIST_SUCCESS',
  ORDER_REQUEST = '@order/ORDER_REQUEST',
  ORDER_SUCCESS = '@order/ORDER_SUCCESS',
  ORDER_CLEAR = '@order/ORDER_CLEAR',
  CLEAR_LOADING = '@order/CLEAR_LOADING',
  ORDER_CANCEL_REQUEST = '@order/ORDER_CANCEL_REQUEST',
  ORDER_CANCEL_SUCCESS = '@order/ORDER_CANCEL_SUCCESS'
}

export enum OrderStatus {
  STATUS_PENDING = 'pending',
  STATUS_PENDING_PAYMENT = 'pending_payment',
  STATUS_PAYMENT_APPROVED = 'payment_approved',
  STATUS_PROCESSING = 'processing',
  STATUS_AVAILABLE = 'available',
  STATUS_AVAILABLE_PICKUP = 'available_pickup',
  STATUS_COMPLETED = 'completed',
  STATUS_SENT = 'sent',
  STATUS_IN_TRANSIT = 'in_transit',
  STATUS_CANCELED = 'canceled',
  STATUS_CLOSED = 'closed',
  STATUS_FRAUD = 'fraud',
}

export interface OrderCustomerData {
  id?: string;
  address?: UserAddresses[];
}

export interface IAdditionalPaymentDetail {
  qr_code?: string;
  expiration?: string;
  ds_data?: {
    threeDSMethodData: string;
    threeDSMethodURL: string;
  };
  challenge_data?: {
    data: string;
    url: string;
  }
}

export interface OrderPaymentDetail {
  card_brand?: string;
  card_last_four?: string;
  card_number?: string;
  customer_doc?: string;
  expiry_date?: string;
  full_name?: string;
  method?: string;
  payment_detail_id?: number;
  status?: string;
  tef_nita?: string;
  tef_token?: string;
  media_type: string;
  media_name: string;
  additional: IAdditionalPaymentDetail;
  nit?: string;
}

export interface DoorsProps {
  door_id: string;
}

export interface AddressLockerProps {
  address: string;
  neighborhood: string;
  complement: string;
  city: string;
  state: string;
  postcode: string;
  country_name: string;
}

export interface StoreLockerProps {
  store_id: number;
  store_name: string;
}

export interface LockerOrder {
  locker_id: string;
  token: string;
  doors: DoorsProps[];
  address: AddressLockerProps;
  store?: StoreLockerProps;
}

export interface OrderData {
  order_id?: number;
  cart_id?: number;
  sub_total?: string;
  discount_amount?: string;
  grand_total?: string;
  status_label?: string;
  status?: 'payment_approved';
  customer?: OrderCustomerData;
  created_at?: string;
  items?: ProductData[];
  shipping?: UserAddresses;
  payment_detail?: OrderPaymentDetail[];
  locker?: LockerOrder;
  shipping_method?: 'store' | 'locker' | null;
  shipping_date?: string;
  shipping_amount?: string
}

export interface OrderDataProps {
  orders?: OrderData[],
  current_page?: number,
  first_page_url?: string,
  last_page?: number,
  last_page_url?: string,
  next_page_url?: string,
  path?: string,
  per_page?: number,
  prev_page_url?: string,
  to?: number,
  total?: number,
}

export interface errorData {
  code: string;
  message: string;
  data: string;
}

export interface orderListProps {
  customer_id?: string;
  page?: string;
  limit?: string;
  sort?: string;
  order?: string;
}

export interface OrderState {
  readonly loading: boolean;
  readonly error: boolean;
  readonly errorData?: errorData;
  readonly orders?: OrderDataProps;
  readonly order?: OrderData;
}
